var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 94,
    viewBox: "0 0 135 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_1_",
    "data-name": "Home (1)",
    transform: "translate(-0.111 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_130",
    "data-name": "Groupe 130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 135,
    height: 94,
    rx: 6,
    transform: "translate(0.111 -0.081)",
    fill: "#3c9de0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_131",
    "data-name": "Groupe 131",
    transform: "translate(9.887 19.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M117.633,34.094a4.4,4.4,0,1,0,5.121,3.541,4.4,4.4,0,0,0-5.121-3.541ZM119.9,19.331a4.4,4.4,0,1,1-5.119-3.539A4.426,4.426,0,0,1,119.9,19.331ZM104.535,46.21c-5.586.933-8.987-1.76-10.043-7.744l-2.36-13.384-4,.709-.895-5.07,4-.707L90.2,14.13,97.251,12l1.188,6.744,6.184-1.091.186,5.194-5.477.966,2.335,13.231c.465,2.636,1.5,3.5,3.33,3.178a5.992,5.992,0,0,0,2.872-1.5l3.3,4.177a12.9,12.9,0,0,1-6.63,3.312ZM85.02,28.635,88.47,48.2l-7.2,1.269-3.236-18.35c-.544-3.094-1.812-3.757-3.636-3.437-2.079.367-3.46,2.022-4.51,4.665L73.16,50.9l-7.2,1.27L61.224,25.305l6.237-1.1,1.155,3.3a10.271,10.271,0,0,1,7.471-5.653c4.716-.83,8.041,1.717,8.934,6.789ZM50.654,38.3c-.715-4.057-2.549-6.451-6-5.843-2.837.5-4.272,2.74-3.734,7.871l9.784-1.725ZM58.5,41.886,41.719,44.844c1.417,5.083,4.119,6.176,7.568,5.569a11.053,11.053,0,0,0,6.128-3.488l3.707,3.529A16.1,16.1,0,0,1,49.575,55.9c-8.619,1.518-14.132-3.365-15.615-11.781-1.43-8.11,1.821-15.164,9.679-16.549,7.6-1.341,13.01,2.933,14.521,11.5.161.913.255,2.045.339,2.814Zm-45.154.956c.544,3.094,2.592,4.615,5.329,4.132,2.89-.509,4.106-2.5,3.526-5.8-.564-3.193-2.3-4.455-5.292-3.928-2.738.483-4.08,2.653-3.562,5.594Zm9.733-8.248c3.552.89,5.584,2.623,6.182,6.019.923,5.222-2.615,9.764-9.459,10.974a12.55,12.55,0,0,1-3.206.2,2.2,2.2,0,0,0-.7,1.954c.16.913.768,1.694,3.4,1.229l4.108-.725c6.083-1.071,10.558,1.483,11.346,5.943.956,5.426-3.178,9.552-12.152,11.133-9.835,1.735-13.084-.984-14.032-6.36L15,63.825c.448,2.536,1.76,3.454,6.879,2.551,4.969-.877,6.047-2.476,5.706-4.4-.321-1.824-1.887-2.7-4.726-2.2l-3.954.7c-5.627.992-8.39-1.028-8.889-3.869a6.27,6.27,0,0,1,2.257-5.573c-3.666-1.236-5.5-3.368-6.113-6.815-1.046-5.932,3-10.565,9.738-11.753A21.686,21.686,0,0,0,27.9,27l2.748,5.212A22.446,22.446,0,0,1,23.076,34.593Z",
    transform: "translate(-6 -12)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGent);
export default __webpack_public_path__ + "static/media/logoGent.a710e7cdb6bca9f34dc967b3e9b501fc.svg";
export { ForwardRef as ReactComponent };